import { render, staticRenderFns } from "./AverageFails.vue?vue&type=template&id=4f57deb3&"
import script from "./AverageFails.vue?vue&type=script&lang=js&"
export * from "./AverageFails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports